import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ConverterReaderProtocolEnum } from '@zaoblako/shared/modules/pacs/enums/converter-reader-protocol.enum';
import { ConverterReaderProtocolEnumI18n } from '@zaoblako/shared/modules/pacs/i18n/converter-reader-protocol-enum.i18n';

@Pipe({
  name: 'converterReaderProtocolName',
  standalone: true
})
export class ConverterReaderProtocolNamePipe implements PipeTransform {
  public transform(protocol: ConverterReaderProtocolEnum): string {
    return ConverterReaderProtocolEnumI18n[I18nLocalesEnum.RU_RU][protocol] || '';
  }
}
